import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Login.css';
//import './Login-New.css';
import { Container, Form, FormGroup, Label, Input, Button } from 'reactstrap';
import axios from 'axios';
import { BASE_URL } from "./constants";
import { toast } from 'react-toastify';


const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async () => {
    setError('');
    try {
      const res = await axios.post(`${BASE_URL}/api/chk_user_cred`, { username, password });

      if (res.data?.token) {
        const token = res.data.token;

        // Fetch user info
        const userInfoRes = await axios.get(`${BASE_URL}/api/fetch_user_id`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });

        const { user_name, user_id, scty_id, school_name } = userInfoRes.data;
      
        // Fetch user role/menu
        try {
          const userRoleRes = await axios.get(`${BASE_URL}/api/fetch_user_role`, {
            headers: {
              Authorization: `Bearer ${token}`
            }
          });
          // Save menu to localStorage
          localStorage.setItem('user_menu', JSON.stringify(userRoleRes.data || []));
        } catch (menuErr) {
          localStorage.removeItem('user_menu');
        }
      
        //Session time variables
        const sessionStart = Date.now();
        const sessionDuration = (60 * 60 * 1000) * 9; // 60min in ms
        const sessionExpiry = sessionStart + sessionDuration;
      
        localStorage.setItem('session_start', sessionStart);
        localStorage.setItem('session_expiry', sessionExpiry);
      
        localStorage.setItem('token', token);
        localStorage.setItem('username', username);
        localStorage.setItem('user_name', user_name);
        localStorage.setItem('user_id', user_id);
        localStorage.setItem('scty_id', scty_id);
        localStorage.setItem('society_name', school_name);
      
        navigate('/dashboard');
      } else {
        //window.alert(res.data?.error || 'Invalid credentials');
        toast.error(res.data?.error || 'Invalid credentials');
      }
    } catch (err) {
      console.error('Login error:', err);
      window.alert(err.response?.data?.error || 'Login failed. Please try again.');
    }
  };

  return (
    <div className='page'>
      {/* <div className='header-container'>
        <img src='habitech-logo.png' width="55" height="55" alt="Logo" className='logo' /> &nbsp; &nbsp;&nbsp;&nbsp;
        <h3 className='title'>HabiTech</h3>
      </div> */}
      <div className='header-container'>
        <img src='eschool-logo.png' width="55" height="55" alt="Logo" className='logo' /> &nbsp;&nbsp;&nbsp;
        <div className="title-group">
          <h3 className='title'>eSchool</h3>
          <p className="tagline">Digital Platform for Modern Schools</p>
        </div>
      </div>
      <div className="centered-page">
        <div className="custom-container">
          <div className="login-container">
            <div className='floating-container'>
              <h3 className="heading">User Login</h3>
            </div>
            <Form>
              <FormGroup className='mt-4'>
                <Label for="username">Login ID</Label>
                <Input
                  type="text"
                  placeholder="Login Id"
                  className="form-control input-field"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
              </FormGroup>
              <FormGroup className='mb-4'>
                <Label for="password">Login Password</Label>
                <Input
                  type="password"
                  placeholder="Password"
                  className="form-control input-field"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </FormGroup>
              <Button  className="login_btn1" onClick={handleLogin}>
                Login
              </Button>
              {error && <p className="text-danger mt-2">{error}</p>}
            </Form>
          </div>
          {/* <div className='bottom mt-2'>by ANZA Software Technologies color="primary"
          </div> */}
        </div>
      </div>

      <footer className='footer'>
        <Container>
          <p className='footer-text'>© 2026 eSchool by Anza Software Technologies</p>
        </Container>
      </footer>
    </div>
  );
};

export default Login;
